import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
    Container,
    Row,
    Col,
    Button,
    Carousel,
    CarouselItem,
    CarouselIndicators,
} from "reactstrap";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";

import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar"; // Assuming you have this navbar component
import ProgramPageHeader from "../../components/Headers/ProgramPageHeader"; // Assuming you have this header component
import DefaultFooter from "../../components/Footers/DefaultFooter"; // Assuming you have this footer component

const ProgramPage = () => {
    const { id_program } = useParams(); // Get the program id from the URL params
    const [data, setData] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        AOS.init({ duration: 700, easing: "ease-in-out", once: true });

        // Initialize body styles or clean up on unmount
        document.body.classList.add("profile-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);

        // Fetch program data
        fetchProgramData();

        return () => {
            document.body.classList.remove("profile-page", "sidebar-collapse");
        };
    }, [id_program]);

    const fetchProgramData = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/program/readProgramById/${id_program}`
            );
            setData(response.data);
        } catch (error) {
            console.error("Error fetching program data:", error);
        }
    };

    if (!data) {
        return <div>Loading...</div>;
    }

    const {
        title,
        penjelasan,
        foto_slider,
        foto_slider2,
        foto_slider3,
        foto_slider4,
        foto_slider5,
        foto_slider6,
    } = data;

    const images = [
        foto_slider,
        foto_slider2,
        foto_slider3,
        foto_slider4,
        foto_slider5,
        foto_slider6,
    ].filter(Boolean);

    const onExiting = () => setAnimating(true);
    const onExited = () => setAnimating(false);

    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === images.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? images.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };

    const goToIndex = (newIndex) => {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    return (
        <>
            {/* Navbar */}
            <ExamplesNavbar />

            {/* Page Header */}
            <ProgramPageHeader id_program={id_program} />

            <div className="wrapper">
                {/* Main Content */}
                <section id="program">
                    <Container className="container-program flex mtop">
                        <Row className="title">
                            <Col>
                                {/* Add any title or heading */}
                                <h2>{title}</h2>
                            </Col>
                        </Row>

                        <Row className="left" data-aos="fade-up" data-aos-duration="500">
                            <Col>
                                <p>{penjelasan}</p>
                            </Col>
                        </Row>

                        {/* Carousel Section */}
                        <Row className="justify-content-center">
                            <Col lg="8" md="10" data-aos="zoom-in" style={{ marginBottom: "30px" }}>
                                <Carousel activeIndex={activeIndex} next={next} previous={previous}>
                                    <CarouselIndicators
                                        items={images}
                                        activeIndex={activeIndex}
                                        onClickHandler={goToIndex}
                                    />
                                    {images.map((image, index) => (
                                        <CarouselItem
                                            onExiting={onExiting}
                                            onExited={onExited}
                                            key={index}
                                        >
                                            <img
                                                src={image}
                                                alt={`Slide ${index}`}
                                                className="img-fluid"
                                            />
                                            <div className="carousel-caption d-none d-md-block"></div>
                                        </CarouselItem>
                                    ))}
                                    <a
                                        className="carousel-control-prev"
                                        href="#pablo"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            previous();
                                        }}
                                        role="button"
                                    >
                                        <FaAngleLeft />
                                    </a>
                                    <a
                                        className="carousel-control-next"
                                        href="#pablo"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            next();
                                        }}
                                        role="button"
                                    >
                                        <FaAngleRight />
                                    </a>
                                </Carousel>
                            </Col>
                        </Row>

                        {/* Dots Navigation */}
                        <div className="dots-container">
                            {images.map((_, index) => (
                                <span
                                    key={index}
                                    className={`dot ${activeIndex === index ? "active" : ""}`}
                                    onClick={() => goToIndex(index)}
                                ></span>
                            ))}
                        </div>
                    </Container>
                </section>

                {/* Footer */}
                <DefaultFooter />
            </div>
        </>
    );
};

export default ProgramPage;
